var page = 1; // What page we are on.
var ppp = lb_script_vars.lb_ppp; // Post per page
var total_posts = jQuery('.load-thoughts').data("thoughts") ;

jQuery( "#lb_load_more" ).click(function() {
    console.log('LOAD MORE load-more.js', page, ppp, total_posts, lb_script_vars);
    if ( ( page*ppp ) <= total_posts ){
        get_posts_list();
    } else{
        jQuery('#fp_load_more').addClass('no-more-posts');
    }
});

//Main ajax function
function get_posts_list() {
    loading=true;
    jQuery.ajax({
        type: 'post',
        url: fp_script_vars.ajaxUrl,
        data: {
            action: 'more_post_ajax',
            offset: (page * ppp),
            ppp: ppp
        },
        beforeSend: function () {
            jQuery(".fp-loading").show();
            jQuery("#fp_load_more").hide();
        },
        success: function(posts) {
            posts=jQuery(posts);
            if ( ( page*ppp ) <= total_posts ){
                jQuery(".load-thoughts").append(posts);
                setTimeout(function(){ jQuery(".load-posts").slideDown('slow');
                    jQuery(".fp-loading").hide();
                    jQuery("#fp_load_more").show();
                    jQuery(".load-thoughts div").removeClass('load-posts');
                    page++;

                    if ( ( page*ppp ) >= total_posts ){
                        jQuery('#fp_load_more').addClass('no-more-posts');
                    }
                }, 200);

            } else{
                jQuery('#fp_load_more').addClass('no-more-posts');
            }

        }
    });
}
